import { render, staticRenderFns } from "./VlCover.vue?vue&type=template&id=6b624b3c&scoped=true&"
import script from "./VlCover.vue?vue&type=script&lang=js&"
export * from "./VlCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b624b3c",
  null
  
)

export default component.exports